import { useState } from "react";

// Try Google's favicon service (works without API key, public, reliable).
// On error fall back to a brand-coloured letterform so cards never break.
const LOGO_SOURCES = {
  vattenfall: { domain: "vattenfall.nl", bg: "#FFDA00", fg: "#1B1B1B" },
  essent: { domain: "essent.nl", bg: "#E60000", fg: "#FFFFFF" },
  energiedirect: { domain: "energiedirect.nl", bg: "#FFD600", fg: "#1B1B1B" },
  delta: { domain: "delta.nl", bg: "#00A0AF", fg: "#FFFFFF" },
  frank: { domain: "frankenergie.nl", bg: "#7C3AED", fg: "#FFFFFF" },
  gewoon: { domain: "gewoonenergie.nl", bg: "#10B981", fg: "#FFFFFF" },
  oxxio: { domain: "oxxio.nl", bg: "#0066CC", fg: "#FFFFFF" },
  budget_thuis: { domain: "budgetthuis.nl", bg: "#FF6B00", fg: "#FFFFFF" },
  pricewise: { domain: "pricewise.nl", bg: "#4F46E5", fg: "#FFFFFF" },
};

export default function ProviderLogo({ providerId, name, size = 48, className = "" }) {
  const [errored, setErrored] = useState(false);
  const cfg = LOGO_SOURCES[providerId] || {};
  const letter = (name || "?")[0].toUpperCase();
  const sizePx = `${size}px`;
  const rounded = size >= 40 ? "rounded-xl" : "rounded-lg";

  if (!errored && cfg.domain) {
    return (
      <div
        className={`${rounded} bg-white border border-slate-200 grid place-items-center overflow-hidden flex-shrink-0 ${className}`}
        style={{ width: sizePx, height: sizePx }}
        data-testid={`provider-logo-${providerId}`}
      >
        <img
          src={`https://www.google.com/s2/favicons?domain=${cfg.domain}&sz=128`}
          alt={`${name} logo`}
          loading="lazy"
          onError={() => setErrored(true)}
          style={{ width: size * 0.7, height: size * 0.7, objectFit: "contain" }}
        />
      </div>
    );
  }

  // Fallback: branded letter
  return (
    <div
      className={`${rounded} grid place-items-center flex-shrink-0 font-heading font-bold ${className}`}
      style={{
        width: sizePx,
        height: sizePx,
        backgroundColor: cfg.bg || "#1D4ED8",
        color: cfg.fg || "#FFFFFF",
        fontSize: size * 0.42,
      }}
      data-testid={`provider-logo-${providerId}`}
    >
      {letter}
    </div>
  );
}
